import type { IR2Attachment } from '@common/types/api/r2-types';
import { OfficeService } from '@core/office/office-service/office-service';
import { environment } from '@env';
import { ThreadAttachmentStore } from '@services/r2-file/thread-attachment.store';
import { checkAndCutByBytes } from '@utils/string';

export interface OfficeDocumentContext
{
    attachDocument: string;
    documentAttachments: IR2Attachment[];
}

export async function readOfficeDocumentContext(office: OfficeService, attachments: ThreadAttachmentStore): Promise<OfficeDocumentContext>
{
    const host = office.getHost();
    const text = await host.getDocumentTextAsync();
    const image = await host.getDocumentImageAsync();
    const context: OfficeDocumentContext = {
        attachDocument: await checkAndCutByBytes(text, environment.limits_bytes.ATTACH_DOCUMENT),
        documentAttachments: [],
    };
    if (image)
    {
        const binary = atob(image.includes(',') ? image.substring(image.indexOf(',') + 1) : image);
        const bytes = Uint8Array.from(binary, character => character.charCodeAt(0));
        const file = new File([bytes], 'powerpoint-current-slide.png', { type: 'image/png' });
        context.documentAttachments.push(await attachments.uploadContextFile(file));
    }
    return context;
}
